// extracted by mini-css-extract-plugin
export var childrenContainer = "_3j-0";
export var virtualScrollArea = "_3j-1";